<template>
  <div id="interac-box">
    <SceneQuestionSecondProp @mounted="childMounted()" v-if="isFootballQuiz" :dataApi="dataApiProp" />
    <FootballTemplateNew @mounted="childMounted()" v-else-if="isFootballQuizNew" :dataApi="dataApiProp" />
    <QRCodeShort @mounted="childMounted()" v-else-if="isQrCodeShort" :dataApi="dataApiProp" />
    <QRCodeTop @mounted="childMounted()" v-else-if="isQrCodeTop" :dataApi="dataApiProp" />
    <TemplateLamanh3 @mounted="childMounted()" v-else-if="isTemplateLamanh3" :dataApi="dataApiProp" />
    <QRCodeBottom @mounted="childMounted()" v-else-if="isQrCodeBottom" :dataApi="dataApiProp" />
    <SceneBanner @mounted="childMounted()" v-else-if="isBanner" :dataApi="dataApiProp" />
    <!-- <scene-donate v-else-if="isSceneDonate" /> -->
    <TemplateAd2 @mounted="childMounted()" v-else-if="isPollOverlayAds2" :dataApi="dataApiProp" />
    <TemplateAd2Mobile @mounted="childMounted()" v-else-if="isPollOverlayAds2Mobile" :dataApi="dataApiProp" />
    <TemplateAd1 @mounted="childMounted()" v-else-if="isPollOverlayAds1" :dataApi="dataApiProp" />
    <Template1Pure @mounted="childMounted()" v-else-if="isPollOverlayAds1B" :dataApi="dataApiProp" />
    <TemplateAd1Mobile @mounted="childMounted()" v-else-if="isPollOverlayAds1Mobile" :dataApi="dataApiProp" />
    <TemplateMilionare @mounted="childMounted()" v-else-if="isMilionare" :dataApi="dataApiProp" />
    <TemplateMilionareMobile @mounted="childMounted()" v-else-if="isMilionareMobile" :dataApi="dataApiProp" />
    <VinaSports01 @mounted="childMounted()" v-else-if="isPollOverlayAds1New" :dataApi="dataApiProp" />
    <TemplateKol @mounted="childMounted()" v-else-if="isPollOverlayKol" :dataApi="dataApiProp" />
    <TemplateHeadline @mounted="childMounted()" v-else-if="isTemplateHeadline" :dataApi="dataApiProp" />
    <VietLotteQuizMobile @mounted="childMounted()" v-else-if="isVietLotteQuizMobile" :dataApi="dataApiProp" />
    <BaseTemplate @mounted="childMounted()" v-else-if="isBaseTemplate" :apiData="apiData" />
    <TemplateOnPlay2 @mounted="childMounted()" v-else-if="isTemplateOnPlay2" :apiData="apiData"></TemplateOnPlay2>
    <TemplateScoreBoard2 @mounted="childMounted()" v-else-if="isTemplateScoreBoard2" :apiData="apiData"> </TemplateScoreBoard2>
    <TemplateResultBoard @mounted="childMounted()" v-else-if="isResultBoard" />
    <TemplateKol2 @mounted="childMounted()" v-else-if="isKOl2" :dataApi="dataApiProp" />
    <BackgroundTemplate @mounted="childMounted()" v-else-if="isBackground" :dataApi="dataApiProp" />
    <TemplateOnPlayChart @mounted="childMounted()" v-else-if="isOnPlayChart" :apiData="dataApiProp" />
    <TemplateOnPlayResult @mounted="childMounted()" v-else-if="isTemplateOnPlayResult" :apiData="apiData"> </TemplateOnPlayResult>
    <TemplateOnPlayResult2Inline @mounted="childMounted()" v-else-if="isTemplateOnPlayResult2Inline" :apiData="apiData"> </TemplateOnPlayResult2Inline>
    <TemplateOnPlayResult2Popup @mounted="childMounted()" v-else-if="isTemplateOnPlayResult2Popup" :apiData="apiData"> </TemplateOnPlayResult2Popup>
    <TemplateOnPlayResult3 @mounted="childMounted()" v-else-if="isTemplateOnPlayResult3" :apiData="apiData"> </TemplateOnPlayResult3>
    <TemplateBranching @mounted="childMounted()" v-else-if="isTemplateBranching" :apiData="apiData"></TemplateBranching>
    <TemplateOnlive @mounted="childMounted()" v-else-if="isTemplateOnlive" :apiData="dataApiProp" />
    <TemplateOnliveV2 @mounted="childMounted()" v-else-if="isTemplateOnliveV2" :apiData="dataApiProp" />
    <TemplateGiftcode @mounted="childMounted()" v-else-if="isTemplateGiftcode" :apiData="dataApiProp" />
    <TemplateLamanh @mounted="childMounted()" v-else-if="isTemplateLamanh" :apiData="dataApiProp" />
    <TemplateNew @mounted="childMounted()" v-else-if="isTemplateNew" :apiData="dataApiProp" />
    <TemplateSound @mounted="childMounted()" v-else-if="isTemplateSound" :apiData="dataApiProp" />
    <TemplateMutiChoices @mounted="childMounted()" v-else-if="isTemplateMutiChoices" :apiData="dataApiProp" />
    <TemplateDevTest @mounted="childMounted()" v-else-if="isTemplateDevTest" :apiData="dataApiProp" />
    <TemplateTwinkingStar @mounted="childMounted()" v-else-if="isTemplateTwinkingStar" :apiData="dataApiProp" />
    <TemplateTestVue @mounted="childMounted()" v-else-if="isTemplateTestVue" :dataApi="dataApiProp" />
    <TemplateLottery @mounted="childMounted()" v-else-if="isTemplateLottery" :apiData="dataApiProp" />
    <TemplateLottery2 @mounted="childMounted()" v-else-if="isTemplateLottery2" :apiData="dataApiProp" />
    <TemplateLottery3 @mounted="childMounted()" v-else-if="isTemplateLottery3" :apiData="dataApiProp" />
    <TemplatePredict @mounted="childMounted()" v-else-if="isTemplatePredict" :apiData="dataApiProp" />
    <TemplateValorant @mounted="childMounted()" v-else-if="isTemplateValorant" :apiData="dataApiProp" />
    <TemplatePubg @mounted="childMounted()" v-else-if="isTemplatePubg" :apiData="dataApiProp" />
    <TemplateTestIos @mounted="childMounted()" v-else-if="isTemplateTestIos" :apiData="dataApiProp" />
    <TemplateTestAndroid @mounted="childMounted()" v-else-if="isTemplateTestAndroid" :apiData="dataApiProp" />
    <TemplateLuckyNumber @mounted="childMounted()" v-else-if="isTemplateLuckyNumber" :apiData="dataApiProp" />
    <TemplateLuckyTet @mounted="childMounted()" v-else-if="isTemplateLuckyTet" :apiData="dataApiProp" />
    <TemplateLuckyState @mounted="childMounted()" v-else-if="isTemplateLuckyState" :apiData="dataApiProp" />
    <TemplatePredictValorant @mounted="childMounted()" v-else-if="isTemplatePredictValorant" :apiData="dataApiProp" />
    <TemplateLamanh2 @mounted="childMounted()" v-else-if="isTemplateLamAnh2" :apiData="dataApiProp" />
    <TemplateMusic @mounted="childMounted()" v-else-if="isTemplateMusic" :apiData="dataApiProp" />
    <TemplateOnliveTet @mounted="childMounted()" v-else-if="isTemplateOnLiveTet" :apiData="dataApiProp" />
    <TemplateOnliveCs2 @mounted="childMounted()" v-else-if="isTemplateOnliveCs2" :apiData="dataApiProp" />
    <TemplateHolidayTet @mounted="childMounted()" v-else-if="isTemplateHolidayTet" :apiData="dataApiProp" />
    <TemplateGameCaro @mounted="childMounted()" v-else-if="isTemplateGameCaro" :apiData="dataApiProp" />
    <TemplateCaro @mounted="childMounted()" v-else-if="isTemplateCaro" :apiData="dataApiProp" />
    <TemplateLuckyNumberOrigin @mounted="childMounted()" v-else-if="isTemplateLuckyNumberOrigin" :apiData="dataApiProp" />
    <TemplateOnliveCs2Test @mounted="childMounted()" v-else-if="isTemplateOnliveCs2Test" :apiData="dataApiProp" />
    <TemplateOnPlus @mounted="childMounted()" v-else-if="isTemplateOnPlus" :apiData="dataApiProp" />
    <TemplateVNAirline @mounted="childMounted()" v-else-if="isTemplateVNAirline" :apiData="dataApiProp" />
    <TemplateLuckyNumberVNA @mounted="childMounted()" v-else-if="isTemplateLuckyNumberVNA" :apiData="dataApiProp" />
    <TemplateOnPlusVolleyball @mounted="childMounted()" v-else-if="isTemplateOnPlusVolleyball" :apiData="dataApiProp" />
    <TemplateEuro @mounted="childMounted()" v-else-if="isTemplateEuro" :apiData="dataApiProp" />
    <TemplateOnPlusLogoBrandVolleyball @mounted="childMounted()" v-else-if="isTemplateOnPlusLogoBrandVolleyball" :apiData="dataApiProp" />
    <TemplateCKTG2024 @mounted="childMounted()" v-else-if="isTemplateCKTG2024" :apiData="dataApiProp" />
    <TemplateCKTG2025 @mounted="childMounted()" v-else-if="isTemplateCKTG2025" :apiData="dataApiProp" />
    <TemplateLuckyNumberValorant @mounted="childMounted()" v-else-if="isTemplateLuckyNumberValorant" :apiData="dataApiProp" />
    <TemplateC1 @mounted="childMounted()" v-else-if="isTemplateC1" :apiData="dataApiProp" />
    <TemplateC1Onplus @mounted="childMounted()" v-else-if="isTemplateC1OnPlus" :apiData="dataApiProp" />
    <TemplateTet2025 @mounted="childMounted()" v-else-if="isTemplateTet2025" :apiData="dataApiProp" />
    <TemplateTet2025V2 @mounted="childMounted()" v-else-if="isTemplateTet2025V2" :apiData="dataApiProp" />
    <TemplatePubgOnliveTv @mounted="childMounted()" v-else-if="isTemplatePubgOnliveTv" :apiData="dataApiProp" />
    <TemplateValorantOnlivetv @mounted="childMounted()" v-else-if="isTemplateValorantOnlivetv" :apiData="dataApiProp" />
    <TemplateOnliveTv @mounted="childMounted()" v-else-if="isTemplateOnliveTv" :apiData="dataApiProp" />
    <TemplateTelcom @mounted="childMounted()" v-else-if="isTemplateTelcom" :apiData="dataApiProp" />
    <TemplateTelcomESport @mounted="childMounted()" v-else-if="isTemplateTelcomESport" :apiData="dataApiProp" />
    <TemplateEntertaiment @mounted="childMounted()" v-else-if="isTemplateEntertaiment" :apiData="dataApiProp" />
    <TemplateAds @mounted="childMounted()" v-else-if="isTemplateAds" :apiData="dataApiProp" />
    <TemplateVTVPrime @mounted="childMounted()" v-else-if="isTemplateVTVPrime" :apiData="dataApiProp" />

    <!-- <div v-if="isVersion">
      <div>
        <h3>Embed - Ver 01.11.2022.01.</h3>
        <form></form>
      </div>
    </div> -->
  </div>
</template>

<script>
import axios from 'axios';
import * as CryptoJS from 'crypto-js';
import { defineAsyncComponent } from 'vue';
import { API_HOST } from '../config';
// import { mockData } from '@/js/mockData';
// import { mockDataListenMessage } from '@/js/mockData';
import { osPostMessage } from '@/js/osPostMessage';
const SCENE_QUEST = 'question';
const SCENE_DONATE = 'donate';
const url = new URL(window.location.href);
// const os = url.searchParams.get("os") || "other";
const deviceType = url.searchParams.get('deviceType') || 'generic';
const tenantId = url.searchParams.get('tenantId') || 'vtvlive';
const duration = url.searchParams.get('duration');
const timelineId = url.searchParams.get('timelineId') || '';
const scene = SCENE_QUEST;

const FootballTemplateNew = defineAsyncComponent(() => import('@/components/SceneQuestionTemplate1.vue'));
const SceneQuestionSecondProp = defineAsyncComponent(() => import('@/components/SceneQuestionSecondProp.vue'));
const QRCodeShort = defineAsyncComponent(() => import('@/components/QRCodeShort.vue'));
const QRCodeTop = defineAsyncComponent(() => import('@/components/QRCodeTop.vue'));
const QRCodeBottom = defineAsyncComponent(() => import('@/components/QRCodeBottom.vue'));
const TemplateLamanh3 = defineAsyncComponent(() => import('@/components/TemplateLamanh3.vue'));
const SceneBanner = defineAsyncComponent(() => import('@/components/SceneBanner.vue'));
const TemplateAd2 = defineAsyncComponent(() => import('./components/TemplateAd2.vue'));
const TemplateAd2Mobile = defineAsyncComponent(() => import('./components/TemplateAd2Mobile.vue'));
const TemplateAd1 = defineAsyncComponent(() => import('./components/TemplateAd1.vue'));
const TemplateAd1Mobile = defineAsyncComponent(() => import('./components/TemplateAd1Mobile.vue'));
const TemplateMilionare = defineAsyncComponent(() => import('./components/TemplateMilionare.vue'));
const TemplateMilionareMobile = defineAsyncComponent(() => import('./components/TemplateMilionareMobile.vue'));
const VinaSports01 = defineAsyncComponent(() => import('./components/VinaSports_01.vue'));
const TemplateKol = defineAsyncComponent(() => import('./components/KOL.vue'));
const TemplateHeadline = defineAsyncComponent(() => import('./components/TemplateHeadline.vue'));
const VietLotteQuizMobile = defineAsyncComponent(() => import('./components/VietLotteQuizMobile.vue'));
const TemplateOnPlayResult = defineAsyncComponent(() => import('./components/TemplateOnPlayResult.vue'));
const TemplateOnPlayResult2Inline = defineAsyncComponent(() => import('./components/TemplateOnPlayResult2Inline.vue'));
const TemplateOnPlayResult2Popup = defineAsyncComponent(() => import('./components/TemplateOnPlayResult2Popup.vue'));
const TemplateBranching = defineAsyncComponent(() => import('./components/TemplateBranching.vue'));
const TemplateOnPlayResult3 = defineAsyncComponent(() => import('./components/TemplateOnPlayResult3.vue'));
const TemplateScoreBoard2 = defineAsyncComponent(() => import('./components/TemplateScoreBoard2.vue'));
const TemplateResultBoard = defineAsyncComponent(() => import('./components/TemplateResultBoard.vue'));
const TemplateKol2 = defineAsyncComponent(() => import('./components/TemplateKol2.vue'));
const BackgroundTemplate = defineAsyncComponent(() => import('./components/BackgroundTemplate.vue'));
const TemplateOnPlayChart = defineAsyncComponent(() => import('./components/TemplateOnPlayChart.vue'));
const TemplateOnPlay2 = defineAsyncComponent(() => import('./components/TemplateOnPlay2.vue'));
const Template1Pure = defineAsyncComponent(() => import('./components/Template1Pure.vue'));
const TemplateOnlive = defineAsyncComponent(() => import('./components/TemplateOnlive.vue'));
const TemplateOnliveV2 = defineAsyncComponent(() => import('./components/TemplateOnliveV2.vue'));
const TemplateGiftcode = defineAsyncComponent(() => import('./components/TemplateGiftcode.vue'));
const TemplateNew = defineAsyncComponent(() => import('./components/TemplateNew.vue'));
const TemplateSound = defineAsyncComponent(() => import('./components/TemplateSound.vue'));
const TemplateMutiChoices = defineAsyncComponent(() => import('@/components/TemplateMutiChoices.vue'));
const TemplateLamanh = defineAsyncComponent(() => import('@/components/TemplateLamanh.vue'));
const TemplateDevTest = defineAsyncComponent(() => import('@/components/TemplateDevTest.vue'));
const TemplateTwinkingStar = defineAsyncComponent(() => import('@/components/TemplateTwinkingStar.vue'));
const TemplateTestVue = defineAsyncComponent(() => import('./components/TemplateFlower.vue'));
const TemplateLottery = defineAsyncComponent(() => import('./components/TemplateLottery.vue'));
const TemplateLottery2 = defineAsyncComponent(() => import('./components/TemplateLottery2.vue'));
const TemplateLottery3 = defineAsyncComponent(() => import('./components/TemplateLottery3.vue'));
const TemplatePredict = defineAsyncComponent(() => import('./components/TemplatePredict.vue'));
const TemplatePubg = defineAsyncComponent(() => import('./components/TemplatePubg.vue'));
const TemplateValorant = defineAsyncComponent(() => import('./components/TemplateValorant.vue'));
const TemplateTestIos = defineAsyncComponent(() => import('./components/TemplateTest.vue'));
const TemplateTestAndroid = defineAsyncComponent(() => import('./components/TemplateFontSizeAnd.vue'));
const TemplateLuckyNumber = defineAsyncComponent(() => import('./components/TemplateLuckyNumber.vue'));
const TemplatePredictValorant = defineAsyncComponent(() => import('./components/TemplatePredictValorant.vue'));
const TemplateLamanh2 = defineAsyncComponent(() => import('./components/TemplateLamAnh2.vue'));
const TemplateMusic = defineAsyncComponent(() => import('./components/TemplateMusic.vue'));
const TemplateLuckyTet = defineAsyncComponent(() => import('./components/LuckyNumberTetHoliday.vue'));
const TemplateLuckyState = defineAsyncComponent(() => import('./components/TemplateLuckyNumberState/TemplateLuckyNumberState.vue'));
const TemplateOnliveTet = defineAsyncComponent(() => import('@/components/TemplateOnliveTet/TemplateOnliveTet.vue'));
const TemplateOnliveCs2 = defineAsyncComponent(() => import('@/components/TemplateOnliveCs2/TemplateOnliveCs2.vue'));
const TemplateHolidayTet = defineAsyncComponent(() => import('@/components/TemplateHolidayTet/TemplateHolidayTet.vue'));
const TemplateGameCaro = defineAsyncComponent(() => import('@/components/TemplateGameCaro/TemplategameCaro.vue'));
const TemplateCaro = defineAsyncComponent(() => import('@/components/TemplateCaro.vue'));
const TemplateLuckyNumberOrigin = defineAsyncComponent(() => import('@/components/TemplateLuckyNumberOrigin/TemplateLuckyNumber.vue'));
const TemplateOnliveCs2Test = defineAsyncComponent(() => import('@/components/TemplateOnliveCs2Test/TemplateOnliveCs2.vue'));
const TemplateOnPlus = defineAsyncComponent(() => import('@/components/TemplateOnPlus/TemplateOnplus.vue'));
const TemplateVNAirline = defineAsyncComponent(() => import('@/components/TemplateVNAirline/TemplateVNAirline.vue'));
const TemplateLuckyNumberVNA = defineAsyncComponent(() => import('@/components/TemplateLuckyNumberVNA/TemplateLuckyNumberVNA.vue'));
const TemplateOnPlusVolleyball = defineAsyncComponent(() => import('@/components/TemplateOnPlusVolleyball/TemplateOnPlusVolleyball.vue'));
const TemplateEuro = defineAsyncComponent(() => import('@/components/TemplateEuro/TemplateEuro.vue'));
const TemplateLuckyNumberValorant = defineAsyncComponent(() => import('@/components/TemplateLuckyNumberValorant/TemplateLuckyNumberValorant.vue'));
const TemplateOnPlusLogoBrandVolleyball = defineAsyncComponent(() => import('@/components/TemplateOnPlusLogoBrandVolleyball/TemplateOnPlusLogoBrandVolleyball.vue'));
const TemplateCKTG2024 = defineAsyncComponent(() => import('@/components/TemplateCKTG2024/TemplateCKTG2024.vue'));
const TemplateCKTG2025 = defineAsyncComponent(() => import('@/components/TemplateCKTG2025/TemplateCKTG2025.vue'));
const TemplateC1 = defineAsyncComponent(() => import('@/components/TemplateC1/TemplateC1.vue'));
const TemplateC1Onplus = defineAsyncComponent(() => import('@/components/TemplateC1Onplus/TemplateC1.vue'));
const TemplateTet2025 = defineAsyncComponent(() => import('@/components/TemplateTet2025/TemplateTet2025.vue'));
const TemplateTet2025V2 = defineAsyncComponent(() => import('@/components/TemplateTet2025V2/TemplateTet2025V2.vue'));
const TemplatePubgOnliveTv = defineAsyncComponent(() => import('@/components/TemplatePubgOnliveTv/TemplatePubgOnliveTv.vue'));
const TemplateValorantOnlivetv = defineAsyncComponent(() => import('@/components/TemplateValorantOnlivetv/TemplateValorantOnlivetv.vue'));
const TemplateOnliveTv = defineAsyncComponent(() => import('@/components/TemplateOnliveTv/TemplateOnliveTv.vue'));
const TemplateTelcom = defineAsyncComponent(() => import('@/components/TemplateTelcom/TemplateTelcom.vue'));
const TemplateTelcomESport = defineAsyncComponent(() => import('@/components/TemplateTelcomESport/TemplateTelcomESport.vue'));
const TemplateEntertaiment = defineAsyncComponent(() => import('@/components/TemplateEntertaiment/TemplateEntertaiment.vue'));
const TemplateAds = defineAsyncComponent(() => import('@/components/TemplateAds/TemplateAds.vue'));
const TemplateVTVPrime = defineAsyncComponent(() => import('@/components/TemplateVTVPrime/TemplateVTVPrime.vue'));
export default {
  name: 'App',
  components: {
    SceneQuestionSecondProp,
    FootballTemplateNew,
    QRCodeShort,
    QRCodeTop,
    QRCodeBottom,
    SceneBanner,
    TemplateAd2,
    TemplateAd2Mobile,
    TemplateAd1,
    TemplateAd1Mobile,
    TemplateMilionare,
    TemplateMilionareMobile,
    VinaSports01,
    TemplateKol,
    TemplateHeadline,
    VietLotteQuizMobile,
    TemplateLamanh3,
    TemplateHolidayTet,
    // BaseTemplate,
    TemplateScoreBoard2,
    TemplateOnPlay2,
    // TemplateResultBoard,
    TemplateResultBoard,
    TemplateKol2,
    BackgroundTemplate,
    TemplateOnPlayResult,
    TemplateOnPlayResult2Inline,
    TemplateOnPlayResult2Popup,
    TemplateOnPlayResult3,
    TemplateOnPlayChart,
    Template1Pure,
    TemplateBranching,
    TemplateOnlive,
    TemplateOnliveV2,
    TemplateNew,
    TemplateSound,
    TemplateMutiChoices,
    TemplateLamanh,
    TemplateGiftcode,
    TemplateDevTest,
    TemplateTwinkingStar,
    TemplateTestVue,
    TemplateLottery,
    TemplateLottery2,
    TemplateLottery3,
    TemplatePredict,
    TemplatePubg,
    TemplateValorant,
    TemplateTestIos,
    TemplateTestAndroid,
    TemplateLuckyNumber,
    TemplatePredictValorant,
    TemplateLamanh2,
    TemplateMusic,
    TemplateLuckyTet,
    TemplateLuckyState,
    TemplateOnliveTet,
    TemplateOnliveCs2,
    TemplateGameCaro,
    TemplateCaro,
    TemplateLuckyNumberOrigin,
    TemplateOnliveCs2Test,
    TemplateOnPlus,
    TemplateVNAirline,
    TemplateLuckyNumberVNA,
    TemplateOnPlusVolleyball,
    TemplateEuro,
    TemplateLuckyNumberValorant,
    TemplateOnPlusLogoBrandVolleyball,
    TemplateCKTG2024,
    TemplateCKTG2025,
    TemplateC1,
    TemplateC1Onplus,
    TemplateTet2025,
    TemplateTet2025V2,
    TemplatePubgOnliveTv,
    TemplateValorantOnlivetv,
    TemplateOnliveTv,
    TemplateTelcom,
    TemplateTelcomESport,
    TemplateEntertaiment,
    TemplateAds,
    TemplateVTVPrime,
  },
  data() {
    return {
      dataApiProp: null,
      counter: 0,
      typeTemplate: '',
      isVersion: false,
      formDataQuestion: {
        scene: SCENE_QUEST,
        question: null,
        result_msg: null,
        answers: null,
      },
      formDataDonate: {
        scene: SCENE_DONATE,
        question: null,
        result_msg: null,
        answers: null,
      },
    };
  },
  computed: {
    apiData() {
      let data = this.dataApiProp;
      data.countdown = this.counter;
      data.typeTemplate = this.typeTemplate;
      return data;
    },
    isResultBoard() {
      return url.searchParams.get('type') === 'resultboard';
    },
    isCallApi() {
      return true; //url.searchParams.get('ws') !== '1';
    },
    isFootballQuiz() {
      return this.dataApiProp && this.typeTemplate == 'FootballV1';
    },
    isFootballQuizNew() {
      return this.dataApiProp && this.typeTemplate == 'Football';
    },
    isQrCodeShort() {
      return this.dataApiProp && this.typeTemplate == 'QrCodeShort';
    },
    isQrCodeTop() {
      return this.dataApiProp && this.typeTemplate == 'QrCodeTop';
    },
    isTemplateLamanh3() {
      return this.dataApiProp && this.typeTemplate == 'TemplateLamanh3';
    },

    isQrCodeBottom() {
      return this.dataApiProp && this.typeTemplate == 'QrCodeBottom';
    },
    isBanner() {
      return this.dataApiProp && this.typeTemplate == 'Banner';
    },
    isPollOverlayAds2() {
      return this.dataApiProp && this.typeTemplate == 'PollOverlayAds2';
    },
    isPollOverlayAds2Mobile() {
      return this.dataApiProp && this.typeTemplate == 'PollOverlayAds2Mobile';
    },
    isPollOverlayAds1() {
      return this.dataApiProp && this.typeTemplate == 'PollOverlayAds1';
    },
    isPollOverlayAds1B() {
      return this.dataApiProp && this.typeTemplate == 'PollOverlayAds1B';
    },
    isPollOverlayAds1Mobile() {
      return this.dataApiProp && this.typeTemplate == 'PollOverlayAds1Mobile';
    },
    isMilionare() {
      return this.dataApiProp && this.typeTemplate == 'MilionareTemplate';
    },
    isMilionareMobile() {
      return this.dataApiProp && this.typeTemplate == 'MilionareTemplateMobile';
    },
    isPollOverlayAds1New() {
      return this.dataApiProp && this.typeTemplate == 'VinaSportsMobile01';
    },
    isPollOverlayKol() {
      return this.dataApiProp && this.typeTemplate == 'KOL';
    },
    isTemplateHeadline() {
      return this.dataApiProp && this.typeTemplate == 'TemplateHeadline';
    },
    isVietLotteQuizMobile() {
      return this.dataApiProp && this.typeTemplate == 'VietLotteQuizMobile';
    },
    isBaseTemplate() {
      const base = this.typeTemplate === 'Vinasport_01_v2';
      return this.dataApiProp && base;
    },
    isSceneDonate() {
      return scene === SCENE_DONATE;
    },
    isTemplateScoreBoard() {
      return this.dataApiProp && this.typeTemplate == 'ScoreBoard';
    },
    isTemplateOnPlay2() {
      return this.dataApiProp && this.typeTemplate == 'OnPlay';
    },
    isVersionee() {
      return this.isVersion;
    },
    isKOl2() {
      return this.dataApiProp && (url.searchParams.get('type') === 'kol2' || this.typeTemplate == 'kol2');
    },
    isBackground() {
      return this.dataApiProp && this.typeTemplate == 'Background';
    },
    isOnPlayChart() {
      return this.dataApiProp && this.typeTemplate == 'OnPlayChart';
    },
    isTemplateOnPlayResult() {
      return this.dataApiProp && this.typeTemplate == 'OnPlayResult';
    },
    isTemplateOnPlayResult2Inline() {
      return this.dataApiProp && this.typeTemplate == 'OnPlayResult2Inline';
    },
    isTemplateOnPlayResult2Popup() {
      return this.dataApiProp && this.typeTemplate == 'OnPlayResult2Popup';
    },
    isTemplateBranching() {
      return this.dataApiProp && this.typeTemplate == 'TemplateBranching';
    },
    isTemplateOnPlayResult3() {
      return this.dataApiProp && this.typeTemplate == 'OnPlayResult3';
    },
    isTemplateOnlive() {
      return this.dataApiProp && (this.typeTemplate == 'Onlive' || this.typeTemplate == 'OnlivePercent');
    },
    isTemplateOnliveV2() {
      return this.dataApiProp && (this.typeTemplate == 'OnliveV2' || this.typeTemplate == 'OnliveV2Percent');
    },
    isTemplateLamanh() {
      return this.dataApiProp && this.typeTemplate == 'Lamanh';
    },
    isTemplateTwinkingStar() {
      return this.dataApiProp && this.typeTemplate == 'TwinkingStar';
    },
    isTemplateDevTest() {
      return this.dataApiProp && this.typeTemplate == 'DevTest';
    },
    isTemplateGiftcode() {
      return this.dataApiProp && this.typeTemplate == 'Giftcode';
    },
    isTemplateNew() {
      return this.dataApiProp && this.typeTemplate == 'New';
    },
    isTemplateSound() {
      return this.dataApiProp && this.typeTemplate == 'Sound';
    },
    isTemplateMutiChoices() {
      return this.dataApiProp && this.typeTemplate == 'MutiChoices';
    },
    isTemplateTestVue() {
      return this.dataApiProp && this.typeTemplate == 'Flower';
    },
    isTemplateLottery() {
      return this.dataApiProp && (this.typeTemplate == 'Lottery' || this.typeTemplate == 'LotteryPercent');
    },
    isTemplateLottery2() {
      return this.dataApiProp && (this.typeTemplate == 'Lottery2' || this.typeTemplate == 'Lottery2Percent');
    },
    isTemplateLottery3() {
      return this.dataApiProp && (this.typeTemplate == 'Lottery3' || this.typeTemplate == 'Lottery3Percent');
    },
    isTemplatePredict() {
      return this.dataApiProp && this.typeTemplate == 'TemplatePredict';
    },
    isTemplatePubg() {
      return this.dataApiProp && this.typeTemplate == 'TemplatePubg';
    },
    isTemplateValorant() {
      return this.dataApiProp && (this.typeTemplate == 'Valorant' || this.typeTemplate == 'ValorantPercent');
    },
    isTemplateTestIos() {
      return this.dataApiProp && this.typeTemplate == 'TemplateTestIos';
    },
    isTemplateTestAndroid() {
      return this.dataApiProp && this.typeTemplate == 'TemplateTestAndroid';
    },
    isTemplateLuckyNumber() {
      return this.dataApiProp && this.typeTemplate == 'TemplateLuckyNumber';
    },
    isTemplateLuckyTet() {
      return this.dataApiProp && this.typeTemplate == 'TemplateLuckyTet';
    },
    isTemplateLuckyState() {
      return this.dataApiProp && this.typeTemplate == 'TemplateLuckyState';
    },
    isTemplatePredictValorant() {
      return this.dataApiProp && this.typeTemplate == 'TemplatePredictValorant';
    },
    isTemplateLamAnh2() {
      return this.dataApiProp && this.typeTemplate == 'Lamanh2';
    },
    isTemplateMusic() {
      return this.dataApiProp && this.typeTemplate == 'TemplateMusic';
    },
    isTemplateHolidayTet() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateHolidayTet' || this.typeTemplate == 'TemplateTetHolidayPercentDat');
    },
    isTemplateOnLiveTet() {
      return this.dataApiProp && (this.typeTemplate == 'OnLiveTet' || this.typeTemplate == 'OnliveTetPercent');
    },
    isTemplateOnliveCs2() {
      return this.dataApiProp && (this.typeTemplate == 'OnliveCs2' || this.typeTemplate == 'OnliveCs2Percent');
    },
    isTemplateGameCaro() {
      return this.dataApiProp && this.typeTemplate == 'TemplateGameCaro';
    },
    isTemplateCaro() {
      return this.dataApiProp && this.typeTemplate == 'TemplateCaro';
    },
    isTemplateLuckyNumberOrigin() {
      return this.dataApiProp && this.typeTemplate == 'LuckyNumberOrigin';
    },
    isTemplateOnliveCs2Test() {
      return this.dataApiProp && (this.typeTemplate == 'OnliveCs2Test' || this.typeTemplate == 'OnliveCs2PercentTest');
    },
    isTemplateOnPlus() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateOnPlus' || this.typeTemplate == 'OnliveOnPlusPercent');
    },
    isTemplateVNAirline() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateVNAirline' || this.typeTemplate == 'TemplateVNAirlinePercent');
    },
    isTemplateLuckyNumberVNA() {
      return this.dataApiProp && this.typeTemplate == 'TemplateLuckyNumberVNA';
    },
    isTemplateOnPlusVolleyball() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateOnPlusVolleyball' || this.typeTemplate == 'TemplateOnPlusVolleyballPercent');
    },
    isTemplateEuro() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateEuro' || this.typeTemplate == 'TemplateEuroPercent');
    },
    isTemplateC1() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateC1' || this.typeTemplate == 'TemplateC1Percent');
    },
    isTemplateC1OnPlus() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateC1Onplus' || this.typeTemplate == 'TemplateC1OnplusPercent');
    },
    isTemplateLuckyNumberValorant() {
      return this.dataApiProp && this.typeTemplate == 'TemplateLuckyNumberValorant';
    },
    isTemplateOnPlusLogoBrandVolleyball() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateOnPlusLogoBrandVolleyball' || this.typeTemplate == 'BrandVolleyballPercent');
    },
    isTemplateCKTG2024() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateCKTG2024' || this.typeTemplate == 'TemplateCKTG2024Percent');
    },
    isTemplateCKTG2025() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateCKTG2025' || this.typeTemplate == 'TemplateCKTG2025Percent');
    },
    isTemplateTet2025() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateTet2025' || this.typeTemplate == 'TemplateTet2025Percent');
    },
    isTemplateTet2025V2() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateTet2025V2' || this.typeTemplate == 'TemplateTet2025V2Percent');
    },
    isTemplatePubgOnliveTv() {
      return this.dataApiProp && (this.typeTemplate == 'TemplatePubgOnliveTv' || this.typeTemplate == 'TemplatePubgOnliveTvPercent');
    },
    isTemplateValorantOnlivetv() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateValorantOnlivetv' || this.typeTemplate == 'TemplateValorantOnlivetvPercent');
    },
    isTemplateOnliveTv() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateOnliveTv' || this.typeTemplate == 'OnliveTvPercent');
    },
    isTemplateTelcom() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateTelcom' || this.typeTemplate == 'TemplateTelcomPercent');
    },
    isTemplateTelcomESport() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateTelcomESport' || this.typeTemplate == 'TemplateTelcomESportPercent');
    },
    isTemplateEntertaiment() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateEntertaiment' || this.typeTemplate == 'TemplateEntertaimentPercent');
    },
    isTemplateAds() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateAds' || this.typeTemplate == 'TemplateAdsPercent');
    },
    isTemplateVTVPrime() {
      return this.dataApiProp && (this.typeTemplate == 'TemplateVTVPrime' || this.typeTemplate == 'TemplateVTVPrimePercent');
    },
  },
  mounted() {
    if (timelineId) {
      if (this.isCallApi) this.callApi();
      setTimeout(() => {
        this.caculateScale();
      }, 1);
    } else {
      this.isVersion = true;
    }
  },
  methods: {
    // mock() {
    //   // console.log('app mounted', axios, API_HOST, tenantId);
    //   // let dataapi = mockDataListenMessage;
    //   // let dataapi = mockData;
    //   // console.log(`dataapi`, dataapi);
    //   // this.decryptData(dataapi);
    //   // dataapi.template.type = 'TestVue';
    //   this.typeTemplate = dataapi.data.template.type;
    //   this.dataApiProp = dataapi;
    //   this.dataApiProp.timelineId = timelineId;
    //   this.dataApiProp.os = deviceType;
    //   if (duration && Number(dataapi.countdown) > Number(duration)) {
    //     this.dataApiProp.countdown = Number(duration);
    //   }
    //   // if (this.typeTemplate == 'KOL') this.dataApiProp.countdown = 3000;
    //   this.counter = this.dataApiProp.countdown;
    // },
    decryptData(data) {
      if (typeof data.answers === 'string') {
        const sey = data.template.type + timelineId.substring(0, 5) + data.typeTimeline + timelineId.slice(-3);
        const db = CryptoJS.AES.decrypt(data.answers, sey);
        const dd = db.toString(CryptoJS.enc.Utf8);
        data.answers = eval(JSON.parse(JSON.parse(dd).dataToEncrypt));
      }
    },
    caculateScale() {
      let box = document.querySelector('#interac-box > div:first-child');
      let app = document.getElementById('app');
      if (box && app) {
        box.style.transform = 'translateY(0) scale(1)';
        let rate = app.clientHeight / box.clientHeight;
        if (rate < 1) {
          box.style.transform = `translateY(-${(box.clientHeight - app.clientHeight) / 2}px) scale(${rate})`;
        }
      }
    },
    childMounted() {
      this.caculateScale();
    },
    callApi() {
      console.log('call api');
      axios
        .get(`${API_HOST}ctc/contents/overlay-content?timelineId=${timelineId}&deviceType=${deviceType}&x-tenant-id=${tenantId}`)
        .then((response) => {
          let dataapi = response.data.data;
          this.decryptData(dataapi);
          // this.typeTemplate = 'TemplateC1Percent';
          this.typeTemplate = dataapi.template.type;
          this.dataApiProp = dataapi;
          this.dataApiProp.timelineId = timelineId;
          this.dataApiProp.os = deviceType;
          if (duration && Number(dataapi.countdown) > Number(duration)) {
            this.dataApiProp.countdown = Number(duration);
          }
          // if (this.typeTemplate == "KOL") this.dataApiProp.countdown = 3000;
          this.counter = this.dataApiProp.countdown;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    listenHandle(e) {
      console.log('App listen SDK message: ', e.data);
      if (e.data && typeof e.data === 'string') {
        try {
          const parsedData = JSON.parse(e.data);
          if (parsedData.key === 'GET_DATA_INTERACTIVE') {
            const data = parsedData.data;
            this.decryptData(data);
            // dataapi.template.type = "Giftcode";
            this.typeTemplate = data.template.type;
            this.dataApiProp = data;
            this.dataApiProp.timelineId = timelineId;
            this.dataApiProp.os = deviceType;
            if (duration && Number(data.countdown) > Number(duration)) {
              this.dataApiProp.countdown = Number(duration);
            }
            // if (this.typeTemplate == "KOL") this.dataApiProp.countdown = 3000;
            this.counter = this.dataApiProp.countdown;
          }
        } catch (error) {
          console.error('Error parsing JSON:', error);
        }
      }
    },
    loadedOverlay() {
      console.log('Loaded overlay');
      let dataBody = Object.assign({}, { os: deviceType });
      dataBody.localTime = Date.now();
      dataBody.receiveTime = this.localTime;
      dataBody.sessionCode = this.sessionCode;
      let postData = JSON.stringify({
        data: dataBody,
        key: 'LOADED_OVERLAY',
      });
      osPostMessage(deviceType, postData);
    },
  },
  created() {
    if (!this.isCallApi) {
      this.loadedOverlay();
      window.addEventListener('message', this.listenHandle);
    }
    window.addEventListener('resize', () => {
      this.caculateScale();
    });
  },
  unmounted() {
    window.removeEventListener('resize', () => {
      this.caculateScale();
    });
  },
};
</script>

<style>
* {
  box-sizing: inherit;
  background: none;
  margin: 0;
  padding: 0;
  border: none;
  outline: none;
  -webkit-user-select: none;
  -webkit-touch-callout: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

*:focus {
  color: none;
  background: none;
  border: none;
  outline: none;
}

html {
  box-sizing: border-box;
  font-size: 16px;
  font-family: 'Roboto', sans-serif;
  margin: 0 !important;
  padding: 0 !important;
  border: none;
  outline: none;
}

body {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  margin: calc(-1 * env(safe-area-inset-top)) calc(-1 * env(safe-area-inset-right)) calc(-1 * env(safe-area-inset-bottom)) calc(-1 * env(safe-area-inset-left));
}

html,
body {
  text-size-adjust: none !important;
  -webkit-text-size-adjust: none !important;
  -ms-text-size-adjust: none !important;
  -moz-text-size-adjust: none !important;
}

p {
  text-align: center;
  margin: 0;
}

ul {
  padding: 0;
}

li {
  list-style: none;
}

button {
  border: none;
  outline: none;
  cursor: pointer;
}

#app {
  width: 100vw;
  height: 100vh;
}

#interac-box {
  z-index: 2000;
}
</style>
